import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ProductsState, productFeatureKey } from "./products.reducers";

const selectFeature = createFeatureSelector<ProductsState>(productFeatureKey);

export const selectAllProducts = createSelector(
  selectFeature,
  (state) => Object.values(state.entities)
);

export const selectProductEntities = createSelector(
  selectFeature,
  (state) => state.entities
);

export const selectProductById = (id: number) =>
  createSelector(selectProductEntities, (entities) => entities?.[id]);

export const selectIsLoading = createSelector(
  selectFeature,
  (state: ProductsState) => state?.loading || false
);
